module.exports = __webpack_public_path__ + "assets1775130923925/img/error-500.a371eabc.svg";